import React from 'react';
import { SSJBeaconButton } from '../Beacon/Registry';

import './FundingReviewSummary.scss';
import { useSelector } from 'react-redux';
import calendar from '../../../assets/images/calendar.svg';
import rightArrow from '../../../assets/images/continue-icon.svg';
import { isCustomerWebViewEnabled } from '../../../redux/modules/authentication/authentication.module.selectors';

const FundingReviewSummary = ({
  fundingMethodType,
  btnLabel,
  handleClick,
  headerImageUrl,
  title,
  content,
  subTitle,
  footerTitle,
}) => {
  const customerWebViewEnabled = useSelector(isCustomerWebViewEnabled);
  const scheduleACall = 'Schedule a Call';
  return (
    <div className="funding-review">
      {headerImageUrl && (
        <img src={headerImageUrl} alt="Header" className="header-img-url" />
      )}
      <div
        className="funding-review-summary"
        id={btnLabel === scheduleACall ? 'next-steps' : 'review-page'}
      >
        <div className="funding-review-summary_title">{title}</div>
        {subTitle && (
          <div className="funding-review-summary_sub_title">{subTitle}</div>
        )}
        <div className="funding-review-summary_details">
          {fundingMethodType && (
            <table>
              <tbody>
                <tr className="funding-review-summary_details-content">
                  <td className="funding-review-summary_details-content-first">
                    Funding Method
                  </td>
                  <td className="funding-review-summary_details-content-last">
                    {fundingMethodType}
                  </td>
                </tr>
              </tbody>
            </table>
          )}

          {content && (
            <div className="funding-review-summary_desc">{content}</div>
          )}
        </div>

        {footerTitle && (
          <div className="funding-review-summary_footerTitle">
            {footerTitle}
          </div>
        )}
        <SSJBeaconButton
          label={btnLabel}
          className="funding-review-summary_button"
          scale="jumbo"
          icon-align="left"
          onClick={handleClick}
          disabled={btnLabel !== scheduleACall ? customerWebViewEnabled : false}
        >
          {btnLabel === scheduleACall ? (
            <>
              <img
                slot="icon"
                icon-align="right"
                alt={scheduleACall}
                fill="none"
                height="16"
                width="16"
                src={calendar}
              />
            </>
          ) : null}
          {btnLabel === scheduleACall ? (
            <img
              slot="icon"
              icon-align="right"
              alt="Continue Button"
              className="arrow-icon"
              fill="none"
              height="16"
              width="16"
              src={rightArrow}
            />
          ) : null}
        </SSJBeaconButton>
      </div>
    </div>
  );
};

export default FundingReviewSummary;
